import { render } from "./ViewLot.vue?vue&type=template&id=c6210eee"
import script from "./ViewLot.vue?vue&type=script&lang=js"
export * from "./ViewLot.vue?vue&type=script&lang=js"

import "./ViewLot.vue?vue&type=style&index=0&id=c6210eee&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__